import React, { Component } from 'react';
import { Icon, Row, Col } from 'antd';
import util from '@util/index';
import './MonthPro.less';
import { relative } from 'path';
/**
 * 暂无数据
 */
const months = [];
for (let i = 1; i <= 12; i++) {
  months.push(i);
}
export default class Pmgressbar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { per = 0.1, money = 0, nowAimPre } = this.props;
    let monthFinishedNum = 0; // 已完成的月数
    let currentMonthPer = 0; // 当前进行月的进度
    let isOverruns = 'bar-month-finished';
    if (nowAimPre || nowAimPre === 0) {
      if (per > nowAimPre) {
        isOverruns = 'bar-month-finished-red';
      }
    }

    if (per >= 1) {
      monthFinishedNum = 12;
      currentMonthPer = '0.00';
    } else {
      monthFinishedNum = Math.floor(12 * per);
      currentMonthPer = ((12 * per - monthFinishedNum) * 100).toFixed(2);
    }

    const months2 = [];
    for (let i = 1; i <= Math.min(monthFinishedNum, 12); i++) {
      months2.push(i);
    }
    const tips = (
      <div
        className="bar-tip"
        style={{
          position: 'absolute',
          bottom: '10px',
          left: currentMonthPer === '0.00' ? '100%' : `${currentMonthPer}%`,
        }}
      >
        <div className="value-wrapper">
          <span className="value">{util.numberFormat(money)}</span>
          {`${(per * 100).toFixed(2)}%`}
        </div>
        <Icon type="caret-down" style={{ color: '#d5d5d5' }} />
      </div>
    );
    return (
      <div className="bar-month">
        <div className="all">
          <Row gutter={8}>
            {months.map(item => (
              <Col span={2} key={item}>
                <div className="bar-month-item">{item}月</div>
              </Col>
            ))}
          </Row>
        </div>
        <div className="finished">
          <Row gutter={8}>
            {months2.map((item, index) =>
              currentMonthPer !== '0.00' || index < months2.length - 1 ? (
                <Col span={2}>
                  <div className={`bar-month-item  ${isOverruns}`} />
                </Col>
              ) : (
                <Col span={2}>
                  <div className={`bar-month-item  ${isOverruns}`} style={{ position: 'relative' }}>
                    {tips}
                  </div>
                </Col>
              ),
            )}
            {currentMonthPer === '0.00' ? null : (
              <Col span={2}>
                <div
                  className={`bar-month-item  ${isOverruns}`}
                  style={{
                    width: `${currentMonthPer}%`,
                    position: relative,
                  }}
                >
                  {tips}
                </div>
              </Col>
            )}
          </Row>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/comm/Pmgressbar/MonthPro.js